//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        name: {
            required: true,
            type: String
        },
        x: {
            type: Number,
            default: 600
        },
        y: {
            type: Number,
            default: 210
        },
        scale: {
            type: Number,
            default: 1
        }
    },

    computed: {
        width () {
            return 478 * this.scale;
        },
        height () {
            return 415 * this.scale;
        },
        avatar () {
            return this.$store.getters.avatar;
        },
        badge () {
            return this.$store.getters.getBadge(this.name);
        },
        language () {
            return this.$lang.locale;
        }
    }
};
